import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components";

import { FontFamilyBold, FontFamilyRegular } from "../../constants";

// Define Interface
type Props = {
  text?: string;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
}
interface StyledButtonProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
}

const StyledButton = styled.button<StyledButtonProps>`
  border: none;
  border-radius: 34px;
  background-color: #ebebeb;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  background-color: #159953;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  font-family: ${props => props.fontFamilyBold};

  &.disabled{
    background-color: #ebebeb;
    font-family: ${props => props.fontFamilyBold};
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: center;
    color: #bebebe;
  }
  @media (max-width: 576px) {
    font-size: 12px;
  }
`
StyledButton.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular
}

const CustomButton: FC<Props> = ({
  disabled,
  text,
  className,
  onClick
}) => {
  return (
    <StyledButton onClick={() => !disabled && onClick()} className={`${className} ${disabled ? "disabled" : ""}`}><span>{text}</span></StyledButton>
  )
}

CustomButton.defaultProps = {
  disabled: true,
  className: "",
  text: "",
  onClick: () => {}
}

export default CustomButton;